import type { UserType } from '@/types/userType'
import { EntityTypeOf, type EntityRelation } from '@/types/types'

// NOTE: When editing this enum make sure to also edit the `TaskPermission` enum in `roleType.ts`
export enum TaskTypeOf {
  // Municipality
  ALLOCATION_REQUEST_PARKED = 'allocation_request_parked',
  ALLOCATION_REQUEST_RECEIVED_MUNICIPALITY = 'allocation_request_received_municipality',
  ASSESS_FULFILLMENT_BUDGET = 'assess_fulfillment_budget',
  ASSESS_FULFILLMENT_DEADLINE = 'assess_fulfillment_deadline',
  ASSESS_FULFILLMENT_EXCEEDED = 'assess_fulfillment_exceeded',
  ASSESS_FULFILLMENT_MONTHLY_BUDGET = 'assess_fulfillment_monthly_budget',
  CAK_MESSAGE_RECEIVED_CLIENT_DECEASED = 'cak_message_received_client_deceased',
  CAK_MESSAGE_RECEIVED_CLIENT_MOVED = 'cak_message_received_client_moved',
  CHAT_MESSAGE_BY_SUPPLIER = 'chat_message_by_supplier',
  COMPLAINT_RECEIVED_BY_COMPLAINTS_CENTER = 'complaint_received_by_complaints_center',
  COMPLAINT_RESOLVED_BY_SUPPLIER = 'complaint_resolved_by_supplier',
  END_DATE_RECEIVED = 'end_date_received',
  FULFILLMENT_CREDIT_EXPECTED = 'fulfillment_credit_expected',
  MISSING_CREDITOR_NUMBER = 'missing_creditor_number',
  NEW_USER = 'new_user',
  QUOTATION_REQUEST_RESPONDED = 'quotation_request_responded',
  START_DATE_RECEIVED = 'start_date_received',

  // Supplier
  ALLOCATION_CHANGED = 'allocation_changed',
  ALLOCATION_RECEIVED = 'allocation_received',
  ALLOCATION_REQUEST_RECEIVED_SUPPLIER = 'allocation_request_received_supplier',
  CHAT_MESSAGE_BY_MUNICIPALITY = 'chat_message_by_municipality',
  COMPLAINT_FORWARDED_TO_SUPPLIER = 'complaint_forwarded_to_supplier',
  COMPLAINT_RESOLVED_NOT_SATISFIED = 'complaint_resolved_not_satisfied',
  FULFILLMENT_APPROVED = 'fulfillment_approved',
  FULFILLMENT_IN_PROGRESS = 'fulfillment_in_progress',
  FULFILLMENT_REJECTED = 'fulfillment_rejected',
  QUOTATION_ACCEPTED = 'quotation_accepted',
  QUOTATION_DECLINED = 'quotation_declined',
  QUOTATION_REQUEST_RECEIVED = 'quotation_request_received',
  SUPPLIER_FULFILLMENT_CREDIT_EXPECTED = 'supplier_fulfillment_credit_expected',
}

export enum TaskDescriptionContext {
  PRODUCT_NAME = 'product_name',
  SUPPLIER_NAME = 'supplier_name',
  USERNAME = 'username',
  ORGANISATION = 'organisation',
  ALLOCATION_NUMBER = 'allocation_number',
  FULFILLMENT_NUMBER = 'fulfillment_number',
  MUNICIPALITY_NAME = 'municipality_name',
  CLIENT_NAME = 'client_name',
}

export type TaskDescription = {
  context: TaskDescriptionContext
  values: {
    allocation_number?: number
    allocation?: string
    amount?: number
    bsn?: string
    budget?: number
    client?: string
    email?: string
    end_date?: string
    fulfillment_number?: string
    month_year?: string
    month?: string
    municipality_name?: string
    municipality?: string
    organisation?: string
    percentage?: number
    product?: string
    reason?: string
    size?: number
    start_date?: string
    supplier_end_date?: string
    supplier_start_date?: string
    supplier?: string
    year?: string
  }
}

export type TaskType = {
  id: string
  type: TaskTypeOf
  createdAt: string
  createdBy: UserType['id' | 'firstname' | 'lastname']
  read: boolean
  priority: boolean
  subjectId: string
  subjectName: string
  subjectType: EntityTypeOf
  titleDescriptions?: TaskDescription[]
  taskText: TaskDescription
  relations: EntityRelation[]
}

export type ListTypeTask = Record<string, TaskType>
